import { render, staticRenderFns } from "./transport-tab.vue?vue&type=template&id=3820496e&scoped=true"
import script from "./transport-tab.vue?vue&type=script&lang=js"
export * from "./transport-tab.vue?vue&type=script&lang=js"
import style0 from "./transport-tab.vue?vue&type=style&index=0&id=3820496e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3820496e",
  null
  
)

export default component.exports